var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"chart-row"},[_c('div',{staticClass:"chart-column",attrs:{"id":"volume-pie-chart"}}),_vm._v(" "),_c('div',{staticClass:"chart-column",attrs:{"id":"spend-pie-chart"}})])])])])
}]

export { render, staticRenderFns }